// extracted by mini-css-extract-plugin
export default {"infoCardContainer":"battery-info-card_infoCardContainer__u1ecf"};